import axios from "../../../configs/axios";

export interface BrandGuideItem {
  id: string;
  title: string;
  description: string;
  category: string;
  iconType: string;
  iconColor: string;
  fileKey?: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBrandGuideRequest {
  title: string;
  description: string;
  category: string;
  iconType: string;
  iconColor: string;
  fileKey?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export interface UpdateBrandGuideRequest {
  title?: string;
  description?: string;
  category?: string;
  iconType?: string;
  iconColor?: string;
  fileKey?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export const brandGuideAPI = {
  getAllItems: async (search?: string) => {
    const params = search ? { search } : {};
    const response = await axios.get("/admin/brand-guide", { params });
    return response.data.data;
  },

  getItemById: async (id: string) => {
    const response = await axios.get(`/admin/brand-guide/${id}`);
    return response.data.data;
  },

  createItem: async (data: CreateBrandGuideRequest) => {
    const response = await axios.post("/admin/brand-guide", data);
    return response.data.data;
  },

  createItemWithFile: async (data: CreateBrandGuideRequest, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("category", data.category);
    formData.append("iconType", data.iconType);
    formData.append("iconColor", data.iconColor);
    if (data.isActive !== undefined) {
      formData.append("isActive", data.isActive.toString());
    }
    if (data.sortOrder !== undefined) {
      formData.append("sortOrder", data.sortOrder.toString());
    }

    const response = await axios.post("/admin/brand-guide", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  },

  updateItem: async (id: string, data: UpdateBrandGuideRequest) => {
    const response = await axios.put(`/admin/brand-guide/${id}`, data);
    return response.data.data;
  },

  updateItemWithFile: async (
    id: string,
    data: UpdateBrandGuideRequest,
    file: File
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    if (data.title) formData.append("title", data.title);
    if (data.description) formData.append("description", data.description);
    if (data.category) formData.append("category", data.category);
    if (data.iconType) formData.append("iconType", data.iconType);
    if (data.iconColor) formData.append("iconColor", data.iconColor);
    if (data.isActive !== undefined) {
      formData.append("isActive", data.isActive.toString());
    }
    if (data.sortOrder !== undefined) {
      formData.append("sortOrder", data.sortOrder.toString());
    }

    const response = await axios.put(`/admin/brand-guide/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  },

  deleteItem: async (id: string) => {
    const response = await axios.delete(`/admin/brand-guide/${id}`);
    return response.data;
  },

  getDownloadUrl: async (id: string) => {
    const response = await axios.get(`/admin/brand-guide/${id}/download`);
    return response.data.data.downloadUrl;
  },

  getPreviewUrl: async (id: string): Promise<string> => {
    const response = await axios.get(`/admin/brand-guide/${id}/download`);
    return response.data.data.downloadUrl;
  },
};
